// extracted by mini-css-extract-plugin
export default {"projects":"Research_projects__hIAMU","projectCard":"Research_projectCard__copwT"};